// extracted by mini-css-extract-plugin
export default {"heading":"heading__YjI1Z","strong":"strong__ODExM","h1":"h1__M2ZlM","h2":"h2__NmM3O","h3":"h3__ZjU5Z","h4":"h4__ZmRiZ","h5":"h5__YTE3M","h6":"h6__YTg2N"};